import { useState, useEffect, useRef, useCallback } from 'react';
import ModalAlert from '../ModalAlert';

const Modal = () => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState(null);
    const [showConfirm, setShowConfirm] = useState(true);
    const [showCancel, setShowCancel] = useState(false);
    const [callBack, setCallBack] = useState(null);
    const [confirmText, setConfirmText] = useState("OK");
    const [cancelText, setCancelText] = useState("Cancelar");

    const singletonRef = useRef(null);

    useEffect(() => {
        singletonRef.current = {
            show,
            title,
            body,
            showConfirm,
            showCancel,
            callBack,
            confirmText,
            cancelText,
            __show,
            __onConfirm,
            __onCancel
        };
    }, [show, title, body, showConfirm, showCancel, callBack, confirmText, cancelText]);

    const __show = useCallback((title, body, showConfirm, showCancel, callBack, confirmText, cancelText) => {
        setTitle(title);
        setBody(body);
        setShow(true);
        setShowConfirm(showConfirm);
        setShowCancel(showCancel);
        setCallBack(callBack);
        setConfirmText(confirmText);
        setCancelText(cancelText);
    }, []);

    const __onConfirm = useCallback(() => {
        if (callBack) callBack();
        setShow(false);
        setShowConfirm(false);
        setShowCancel(false);
    }, [callBack]);

    const __onCancel = useCallback(() => {
        setShow(false);
        setShowConfirm(false);
        setShowCancel(false);
    }, []);

    const showHandler = (title, body, showConfirm = true, showCancel = false, callBack = null, confirmText = "OK", cancelText = "Cancelar") => {
        singletonRef.current.__show(title, body, showConfirm, showCancel, callBack, confirmText, cancelText);
    };

    const onConfirmHandler = () => {
        singletonRef.current.__onConfirm();
    };

    const onCancelHandler = () => {
        singletonRef.current.__onCancel();
    };

    Modal.show = showHandler;
    Modal.onConfirm = onConfirmHandler;
    Modal.onCancel = onCancelHandler;

    return (
        <ModalAlert
            show={show}
            title={title}
            onConfirm={showConfirm ? onConfirmHandler : null}
            onCancel={showCancel ? onCancelHandler : null}
            onConfirmText={confirmText}
            onCancelText={cancelText}
            tamanho={'lg'}>
            {body}
        </ModalAlert>
    );
};

export default Modal;